import { useState, useCallback } from 'react';
import { l204Api } from '../../../services/l204Api';
import { L204Key } from './useL204Record';

export function useL204Navigation(
  onNavigate: (docNo: string, pageNo: number) => Promise<void>,
) {
  const [allKeys, setAllKeys] = useState<L204Key[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of composite keys */
  const loadList = useCallback(async (docNo?: string): Promise<L204Key[]> => {
    const res = await l204Api.list(1, 10000, docNo);
    const keys = (res.data || [])
      .filter(r => r.fl140_01)
      .map(r => ({ docNo: r.fl140_01, pageNo: r.fl140_02 }));
    setAllKeys(keys);
    return keys;
  }, []);

  /** Navigate to a specific index */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allKeys.length || isEditing) return;
    setCurrentIdx(idx);
    const key = allKeys[idx];
    await onNavigate(key.docNo, key.pageNo);
  }, [allKeys, onNavigate]);

  /** Find index of a composite key */
  const findIdx = useCallback((docNo: string, pageNo: number): number => {
    return allKeys.findIndex(k => k.docNo === docNo && k.pageNo === pageNo);
  }, [allKeys]);

  return {
    allKeys, currentIdx,
    setAllKeys, setCurrentIdx,
    loadList, navTo, findIdx,
  };
}
